export default {
    user: state => {
        return { ...state.user
        }
    },
    portal: state => {
        return { ...state.portal
        }
    },
    userId: state => {
        return state.user.id
    },
    userFoto: state => {
        if ('foto' in state.user)
            return state.user.foto
        return ''
    },
    userPublicId: state => {
        if ('public_id' in state.user)
            return state.user.public_id
        return ''
    },
    userActivado: state => {
        return state.user.id > 0 && !(
            state.user.email == ("" || null) ||
            state.user.name == ("" || null) ||
            state.user.apellido == ("" || null) ||
            state.user.telefono == ("" || null) ||
            state.user.sexo == ("" || null) ||
            state.user.cambio_password == (1 || null) ||
            state.user.direccion == ("" || null))
    },
}
